<template>
  <v-menu
    v-model="timeMenu"
    style
    offset-y
    :close-on-content-click="false"
    ref="timeMenu"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formattedTime"
        dense
        readonly
        required
        :label="fieldLabel"
        :rules="timeRules"
        prepend-icon="event"
        class="px-2"
        v-on="on"
      />
    </template>
    <v-time-picker
      v-model="time"
      ampm-in-title
      :format="this.getFormat"
      :min="min"
      :max="max"
      width="320px"
      v-click-outside="saveValue"
    >
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="timeMenu = false; time = pastTime"
      >
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="saveValue(); timeMenu = false"
      >
        OK
      </v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
import DateTimeUtil from '../../util/date-time-util';

export default {
  name: 'TimePickerField',

  props: {
    value: String,
    label: String,
    min: String,
    max: String,
    rules: Array,
  },

  data() {
    return {
      timeMenu: false,
      time: this.value,
      timeRules: this.rules,
      pastTime: null,
    };
  },

  computed: {
    fieldLabel() {
      return `${this.label} (HH:mm)`;
    },

    formattedTime() {
      return DateTimeUtil.getFormattedHours(this.time);
    },

    getFormat() {
      if (DateTimeUtil.is24HourTimeUsed()) {
        return '24hr';
      }
      return 'ampm';
    },
  },

  methods: {
    saveValue() {
      this.$emit('input', this.time);
      this.pastTime = this.time;
    },
  },
};
</script>

<style scoped>

</style>
